import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from 'react-router-dom';
import AppCtrl from "../../control/AppCtrl";
import Config from "../../utils/Config";
import EPage from "../../utils/EPage";
import styles from "./index.module.scss";
import AnimatedBG from "../common/AnimatedBG";

//import EFunction from "../../utils/FunctionPage";
import useAlert from "../../hook/useAlert";
import useBroadcasts from "../../redux/broadcasts/broadcastsAction";
import useGuoZhao from "../../redux/guoZhao/guoZhaoAction";
import useLobbyMachines from "../../redux/lobbyMachines/lobbyMachinesAction";
import FishTypeBuildMachineStep from "../../utils/FishTypeBuildMachineStep";
import LANGUAGE_TYPE from "../../utils/Language";
import LayoutType from "../../utils/LayoutType";
import ScreenOrientation from "../../utils/Orientation";
import UILayout from "../../utils/UILayout";
import Utils from "../../utils/Utils";
import BroadcastPanel from "../BroadcastPanel";
import Banners from "../MainPage/WinLobbyPage/Banners";

const uiBtns = [];
const uiDescs = [];
const uiSpies = [];
let registerEventTimeout = null;
let curMachineInfos = null;
let m_machineInfos = null;
let mBlockingChooseMachine = false;
function LobbyPage() {
  const { lobbyMachines } = useLobbyMachines();
  const { guoZhao } = useGuoZhao();
  const { broadcasts } = useBroadcasts();
  const { showAlert } = useAlert();
  // // const navigate = useNavigate();
  //===========================================================================
  const [machineInfos, setMachineInfos] = useState(null);

  const containerRef = useRef(null);
  const iframeRef = useRef(null);

  // ==== Robot mode states/timers ====
  const robotTimerRef = useRef(null);
  const robotCountdownRef = useRef(0);
  const [robotCountdown, setRobotCountdown] = useState(null);
  // ==================================

  // const forcePcMode = Config.forcePCMode ? Config.forcePCMode : false;
  // var mobileMode = Utils.detectmob() && !forcePcMode;
  const [forceVerticalMode] = useState(() => Config.forceVerticalMode ? Config.forceVerticalMode : false);
  const [mobileMode] = useState(() => Utils.detectmob() || forceVerticalMode);

  useEffect(() => {
    PreLoad();
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    if (lobbyMachines) {
      const lobbyName = AppCtrl.lobbyName();
      const infos = lobbyMachines[lobbyName];
      setMachineInfos(infos);

      const uiShowTitle = document.getElementById("showTitle");
      if (uiShowTitle) {
        uiShowTitle.innerHTML = AppCtrl.lobbyName();
      }

      const uiChatButton = document.getElementById("chatButton");
      const liveChat = Config.liveChat ? Config.liveChat : "";
      const withAPIGame = Config?.withAPIGame ?? false;
      if ((uiChatButton && liveChat === "") || withAPIGame) {
        uiChatButton.disabled = true;
        uiChatButton.style.opacity = 0.5;
      }
    }
  }, [lobbyMachines]);

  useEffect(() => {
    const lobbyName = AppCtrl.lobbyName();
    AppCtrl.getMachineInfos(lobbyName, (objs) => {
      const lobbyMachines = AppCtrl.parseMachineInfos(objs);
      AppCtrl.setLobbyMachines(lobbyMachines);
    });
  }, [guoZhao]);

  useEffect(() => {
    if (isNewMachineInfos(machineInfos)) {
      unregisterEvent();
      // if (mobileMode) layoutChooseMachinePanel_Mobile(machineInfos);
      // else layoutChooseMachinePanel(machineInfos);
      if (!mobileMode) layoutChooseMachinePanel_Mobile(machineInfos);
      else layoutChooseMachinePanel(machineInfos);

      const uiChooseMachines = document.getElementById("chooseMachines");
      if (uiChooseMachines) {
        // hide ui as init
        //uiChooseMachines.style.display = 'none';
        // wait for view append done
        if (registerEventTimeout) clearTimeout(registerEventTimeout);
        registerEventTimeout = setTimeout(function () {
          registerEvent(m_machineInfos);
          // show ui
          uiChooseMachines.style.display = "";
          registerEventTimeout = null;
        }, 1000);
      }
    }
    // 啟動機器人倒數（只啟一次）
    if (AppCtrl.isRobotMode()) {
      startRobotCountdownIfNeeded();
    }
  }, [machineInfos]);
  //===========================================================================

  function PreLoad() {
    const lobbyName = AppCtrl.lobbyName();
    if (Config.lobbynotice) {
      for (let i = 0; i < Config.lobbynotice.length; i++) {
        const lobbynotice = Config.lobbynotice[i].notice;
        const id = Config.lobbynotice[i].id ? Config.lobbynotice[i].id : "";
        if (lobbynotice != "" && !AppCtrl.isInLobby() && lobbyName === id) {
          // AppCtrl.alert(lobbynotice);
          if (!AppCtrl.isRobotMode()) {
            showAlert({ title: lobbynotice });
          }
          AppCtrl.setInLobby(true);
        }
      }
    }
  }

  function componentDidMount() {
    // let body = document.querySelector("body");
    // if (!mobileMode){// {if (mobileMode) {
    //   body.style.backgroundImage = `url("img/loginpage/MachineLobby.jpg?${Math.random()}")`;
    // }
    if (Config.fullScreenLockMachine === true) {
      Utils.enterFullScreen();
    }
    const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
    if (checkOrientationInLobby) {
      AppCtrl.SetOrientationInLobby(ScreenOrientation.LandscapePrimary);
      AppCtrl.LandscapePortraitSetInLobby(ScreenOrientation.LandscapePrimary);
    }
    AppCtrl.setBetWinData([]);
    AppCtrl.setBonusState([]);

    const uiBtnToggleChatPanel = document.getElementById("btnToggleChatPanel");
    if (uiBtnToggleChatPanel) {
      // disable uiBtnToggleChatPanel for now
      uiBtnToggleChatPanel.style.display = "none";
      uiBtnToggleChatPanel.disabled = true;
    }

    const uiBtnExit = document.getElementById("btnExit");
    if (uiBtnExit) uiBtnExit.value = `離開${AppCtrl.lobbyName()}`;

    window.addEventListener("resize", () => {
      onResize();
      calculateScale();
    });
    if (!mobileMode) {//if (mobileMode) {
      relayoutChooseMachinePanel_Mobile();
    }
    onResize();
    calculateScale();
    // if (Config?.urlChooseMachineBGImage) {
    //   if (Utils.isGifByExtension(Config.urlChooseMachineBGImage)) {
    //     document.body.style.backgroundImage = `url('${Config.urlChooseMachineBGImage}')`;
        
    //     document.body.style.backgroundSize = "contain";
    //     document.body.style.backgroundRepeat = "no-repeat";
    //     document.body.style.backgroundPosition = "center center";
    //   }
    //   else {
    //     document.body.style.backgroundImage = `url('${Config.urlChooseMachineBGImage}')`;
    //     document.body.style.backgroundSize = "100% 100%";
    //   }
    // }
    // else if (Config?.urlBGImage) {
    //   if (Utils.isGifByExtension(Config.urlBGImage)) {
    //     document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
    //     document.body.style.backgroundSize = "contain";
    //     document.body.style.backgroundRepeat = "no-repeat";
    //     document.body.style.backgroundPosition = "center center";
    //   }
    //   else {
    //     document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
    //     document.body.style.backgroundSize = "100% 100%";
    //     //document.body.style.backgroundSize = "contain";
    //   }
    // }
    
    
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    //const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
    //if (checkOrientationInLobby)
    //    AppCtrl.FreeOrientationInLobby();
    window.removeEventListener("resize", () => {
      onResize();
    });

    if (registerEventTimeout) clearTimeout(registerEventTimeout);
    registerEventTimeout = null;
    unregisterEvent();

    // 停止機器人倒數
    if (robotTimerRef.current) {
      clearInterval(robotTimerRef.current);
      robotTimerRef.current = null;
    }
    setRobotCountdown(null);

  }

  // ==== Robot helpers ====
  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function formatCountdown(sec) {
    if (sec == null) return "";
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  function startRobotCountdownIfNeeded() {
    if (robotTimerRef.current) return;           // 已啟動
    if (!machineInfos || machineInfos.length === 0) return; // 無資料
    //startRobotCountdown(randInt(5, 25));      // 45秒~2 分鐘
    startRobotCountdown(randInt(45, 120));      // 45秒~2 分鐘
  }
  function startRobotCountdown(seconds) {
    if (robotTimerRef.current) {
      clearInterval(robotTimerRef.current);
      robotTimerRef.current = null;
    }
    robotCountdownRef.current = seconds;
    setRobotCountdown(seconds);
    robotTimerRef.current = setInterval(async () => {
      const next = robotCountdownRef.current - 1;
      robotCountdownRef.current = next;
      setRobotCountdown(next);
      if (next <= 0) {
        clearInterval(robotTimerRef.current);
        robotTimerRef.current = null;
        await autoEnterRandomAvailableMachine();
      }
    }, 1000);
  }
  async function autoEnterRandomAvailableMachine() {
    try {
      const userInfo = AppCtrl.userInfo();
      const infos = m_machineInfos || machineInfos;
      if (!infos || infos.length === 0) {
        // 沒有資料，稍後再試
        startRobotCountdown(randInt(30, 60));
        return;
      }
      // 蒐集所有可用機器
      const candidates = [];
      for (let i = 0; i < infos.length; i++) {
        const arr = infos[i] || [];
        for (let j = 0; j < arr.length; j++) {
          const m = arr[j];
          let available;
          if (typeof m.Available !== "undefined") available = !!m.Available;
          else {
            // 與 UI 生成時相同的可用判斷
            if (!m.User) available = true;
            else if (m.UserName === userInfo.Account) available = true;
            else available = false;
          }
          if (available) candidates.push(m);
        }
      }
      if (candidates.length === 0) {
        // 沒有可用機器，短倒數後重試
        startRobotCountdown(randInt(30, 60));
        return;
      }

      // 隨機挑一台可用機器，bLockGuoZhao 永遠 false
      if (mBlockingChooseMachine) return;
      mBlockingChooseMachine = true;
      const pick = candidates[randInt(0, candidates.length - 1)];
      const warning = await playMachine(pick, false);
      mBlockingChooseMachine = false;
      if (!AppCtrl.isRobotMode()) {
        if (warning) showAlert({ title: `<div style={{color:"#ffffff"}}>${warning}</div>` });
      }
    } catch (e) {
      console.error("autoEnterRandomAvailableMachine error:", e);
      // 發生錯誤時，重新啟動短倒數
      startRobotCountdown(randInt(30, 60));
    }
  }
  // =======================

  function calculateScale() {
    if (containerRef.current && iframeRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;
      const scaleX = containerWidth / 1920;
      const scaleY = containerHeight / 1080;
      const scale = Math.min(scaleX, scaleY);
      containerRef.current.height = `${1080 * scale + 30}px`;

      iframeRef.current.style.transform = `scale(${scale})`;
    }
  }

  function onResize() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;
    //const ctrlPanelHeight = 120;
    const ctrlPanelHeight = 0;
    const uiChooseMachinePanel = document.getElementById("chooseMachinePanel");
    if (uiChooseMachinePanel) {
      uiChooseMachinePanel.style.top = "0px";
      uiChooseMachinePanel.style.height = `${deviceHeight - ctrlPanelHeight}px`;

      const uiCtrlBtnsPanel = document.getElementById("ctrlBtnsPanel");
      if (uiCtrlBtnsPanel) {
        uiCtrlBtnsPanel.style.top = `${deviceHeight - ctrlPanelHeight}px`;
      }
      if (!mobileMode) {//if (mobileMode) {
        relayoutChooseMachinePanel_Mobile();
      }
    }
  }
  function relayoutChooseMachinePanel_Mobile() {
    const lobbyName = AppCtrl.lobbyName();
    let lobbyMachineInfos = AppCtrl.getLobbyMachines();
    let MachineInfos = m_machineInfos
      ? m_machineInfos
      : lobbyMachineInfos[lobbyName];

    if (MachineInfos) {
      unregisterEvent();
      layoutChooseMachinePanel_Mobile(MachineInfos);

      const uiChooseMachines = document.getElementById("chooseMachines");
      if (uiChooseMachines) {
        // hide ui as init
        //uiChooseMachines.style.display = 'none';
        // wait for view append done
        if (registerEventTimeout) clearTimeout(registerEventTimeout);
        registerEventTimeout = setTimeout(function () {
          registerEvent(MachineInfos);
          // show ui
          uiChooseMachines.style.display = "";
        }, 1000);
      }
    }
  }
  //onChat
  function onChat() {
    const liveChat = Config.liveChat ? Config.liveChat : "";
    const withAPIGame = Config?.withAPIGame ?? false;
    if (liveChat != "" && !withAPIGame) {
      window.open(liveChat);
    }
  }

  function isNewMachineInfos(newMachineInfos) {
    if (newMachineInfos) {
      const str1 = curMachineInfos ? JSON.stringify(curMachineInfos) : "";
      const str2 = JSON.stringify(newMachineInfos);
      if (str1 != str2) {
        curMachineInfos = newMachineInfos;
        return true;
      } else {
        const uiChooseMachinePanel =
          document.getElementById("chooseMachinePanel");
        if (uiChooseMachinePanel && uiChooseMachinePanel.children.length == 0)
          return true;
      }
    }
    return false;
  }

  function toggleChatPanel() {
    const uiChatPanel = document.getElementById("chatPanel");
    const uiBtnToggleChatPanel = document.getElementById("btnToggleChatPanel");

    if (uiBtnToggleChatPanel && uiChatPanel) {
      uiBtnToggleChatPanel.value =
        uiChatPanel.style.display == "none" ? "開啟聊天" : "關閉聊天";
    }
    if (uiChatPanel) {
      uiChatPanel.style.display =
        uiChatPanel.style.display == "none" ? "" : "none";
    }
  }

  function backToMainPage() {
    //AppCtrl.askMachineTokenInLobby();
    AppCtrl.getUserScores();
    AppCtrl.leaveLobby();
    AppCtrl.switchPage(EPage.main);
    // navigate('/lobby');
    const msg = `正在回到主頁面\n請稍候。`;
    //content, subcontent = '',iconType = 'error', showButton = true, buttonText = '關閉', showLoading = false, closetimer = 2000
    // AppCtrl.popup(msg);
    if (!AppCtrl.isRobotMode()) {
      showAlert({ title: msg, showConfirmButton: false, timer: 4000 });
    }

    // if (Config?.urlBGImage) {
    //   if (Utils.isGifByExtension(Config.urlBGImage)) {
    //     document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
    //     document.body.style.backgroundSize = "contain";
    //     document.body.style.backgroundRepeat = "no-repeat";
    //     document.body.style.backgroundPosition = "center center";
    //   }
    //   else {
    //     document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
    //     document.body.style.backgroundSize = "100% 100%";
    //     //document.body.style.backgroundSize = "contain";
    //   }
    // }
  }

  function spyMachine(machine) {
    AppCtrl.lockSpyMachine(machine.MachineName, (objRes) => {
      // popup message
      let warning = "";
      if (objRes.status == "success") {
        const viewType =
          objRes.hasOwnProperty("GameUI") &&
          objRes.GameUI.hasOwnProperty("view")
            ? objRes.GameUI["view"]
            : UILayout.Unknown;
        console.log(`viewType:${viewType}`);
        // switch to machine spy page
        switch (viewType) {
          case UILayout.Classic:
            // navigate('/spyClassic');
            AppCtrl.switchPage(EPage.spyClassic);
            break;
          case UILayout.Baccarat:
            // navigate('/spyClassic');
            AppCtrl.switchPage(EPage.spyClassic);
            break;
          default:
            // navigate('/spyClassic');
            AppCtrl.switchPage(EPage.spyClassic);
            break;
        }
        // navigate('/spyClassic');
      } else {
        warning = objRes.message;
      }

      if (!AppCtrl.isRobotMode()) {
        if (warning != "") showAlert({ title: warning }); 
      }

    });
  }

  function playMachine(machine, bLockGuoZhao) {
    const myPromise = new Promise((resolve, reject) => {
      let deviceId = machine.hasOwnProperty("deviceId")
        ? machine["deviceId"]
        : -1;
      let machineId = machine.hasOwnProperty("machineId")
        ? machine["machineId"]
        : -1;
      if (deviceId < 0 || machineId < 0) {
        if (machine.hasOwnProperty("machineName")) {
          let targetMachine = null;
          const machineName = machine["machineName"];
          const devices = mLobbyMachines[lobbyName];
          devices.forEach((machines) => {
            machines.forEach((machine) => {
              if (!targetMachine && machine.MachineName == machineName) {
                targetMachine = machine;
              }
            });
          });
          if (targetMachine) {
            deviceId = targetMachine.deviceId;
            machineId = targetMachine.machineId;
          }
        }
      }

      AppCtrl.lockMachine(deviceId, machineId, bLockGuoZhao, (objRes) => {
        // popup message
        let warning = "";
        if (objRes.status == "success") {
          const viewType =
            objRes.hasOwnProperty("GameUI") &&
            objRes.GameUI.hasOwnProperty("view")
              ? objRes.GameUI["view"]
              : UILayout.Unknown;
          console.log(`viewType:${viewType}`);
          // switch to machine page
          switch (viewType) {
            case UILayout.Classic:
              // navigate('/spyClassic');
              AppCtrl.switchPage(EPage.playClassic);
              break;
            case UILayout.Baccarat:
              // navigate('/playBJ');
              AppCtrl.switchPage(EPage.playBJ);
              break;
            default:
              // navigate('/spyClassic');
              AppCtrl.switchPage(EPage.playClassic);
              break;
          }

          const DefaultCreditInLimit = objRes.hasOwnProperty(
            "DefaultCreditInLimit"
          )
            ? objRes["DefaultCreditInLimit"].toString()
            : "0";
          const iDefaultCreditInLimit = parseInt(DefaultCreditInLimit, 10);
          if (iDefaultCreditInLimit > 0) {
            warning += `<h5>\r\n開分上限提示請注意:\r\n此機種開分上限為: ${iDefaultCreditInLimit.toString()}\r\n若分數大於等於此分數後\r\n玩家繼續進行開分將會繼續扣點，\r\n並且機台無法加入點數，\r\n此狀況請注意我們\r\n並不補回遺失點數，\r\n但遊戲中贏得的分數\r\n不在此限。\r\n</h5>`;
            //"\r\n開分上限提示請注意:\r\n" + "此機種開分上限為: " + iDefaultCreditInLimit.toString() + "\r\n若分數大於等於此分數後" + "\r\n玩家繼續進行開分將會繼續扣點，" + "\r\n並且機台無法加入點數，" + "\r\n此狀況請注意我們\r\n並不補回遺失點數，\r\n但遊戲中贏得的分數\r\n不在此限。\r\n";
          }

          let GameLoginMSG = objRes.hasOwnProperty("GameLoginMSG")
            ? objRes["GameLoginMSG"].toString()
            : "";
          //GameLoginMSG = GameLoginMSG.replace(";;", "\r\n");

          if (GameLoginMSG != null && GameLoginMSG != "") {
            if (warning != "") warning += "\r\n";

            warning += `遊戲小提示!!!\r\n`; //"遊戲小提示!!!\r\n";
            // ES5 without the for loop:
            warning += `<h5>`;

            let sSplit = "";
            if (GameLoginMSG.search(";") != -1) {
              sSplit = GameLoginMSG.split(";");
              //console.log(sSplit);

              for (let i = 0; i < sSplit.length; i++) {
                if (sSplit[i].search("img") === -1) {
                  warning += sSplit[i] + "\r\n";
                } else {
                  let imgUrl = sSplit[i].replace("img:", "");
                  imgUrl = imgUrl.replace("\r\n", "");
                  //let imagecontent = `<iframe src="${imgUrl}" style="width:100%;border-width:0px;overflow-y:auto"></iframe>`;
                  //<img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600"></img>
                  let imagecontent = `<img class="fit-picture" id="${i}" src="${imgUrl}" width="100%" height="100%"></img>`;
                  imagecontent += "\r\n";
                  warning += imagecontent;
                }
              }
            } else {
              warning += GameLoginMSG;
            }
            warning += `</h5>`;
          }
          curMachineInfos = null;
        } else {
          warning = objRes.message;
        }
        resolve(warning);
      });
    });

    return myPromise;
  }

  async function onChooseMachineBtnClicked(e) {
    try {
      AppCtrl.setMachineTokenInLobby(false);
      if (mBlockingChooseMachine) {
        console.log("skip onChooseMachineBtnClicked");
        return;
      }
      mBlockingChooseMachine = true;
      //if (!machineInfos || machineInfos.length === 0) throw new Error('machineInfos is null');
      if (!m_machineInfos || m_machineInfos.length === 0)
        throw new Error("m_machineInfos is null");

      const ui = e.currentTarget;
      const id = e.currentTarget.id;
      if (!ui) throw new Error(`機器錯誤編號 ${id} 該機器已經不存在`);

      const strParams = id.split("_");
      if (strParams.length != 2) throw new Error(`機器錯誤編號: ${id} `);

      const language = AppCtrl.getLanguage();
      const arduinoIndex = parseInt(strParams[0]);
      const machineIndex = parseInt(strParams[1]);
      const machine = m_machineInfos[arduinoIndex][machineIndex];
      const userInfo = AppCtrl.userInfo();
      const guoZhaoInfo = userInfo.guoZhaoInfo();

      if (
        guoZhaoInfo != null &&
        (guoZhaoInfo.DeviceId != machine.deviceId ||
          guoZhaoInfo.MachineId != machine.machineId)
      ) {
        let guoZhaoMachine = null;
        // locate user's GuoZhao machine
        const machines = m_machineInfos[guoZhaoInfo.DeviceId];
        for (let i = 0; i < machines.length; i++) {
          if (
            machines[i].deviceId == guoZhaoInfo.DeviceId &&
            machines[i].machineId == guoZhaoInfo.MachineId
          ) {
            guoZhaoMachine = machines[i];
            break;
          }
        }
        let msg = "";
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            if (guoZhaoMachine)
              msg = `您正過招中，請使用${guoZhaoMachine.MachineName}`;
            else msg = `您正在其他機台過招中`;
            break;
          case LANGUAGE_TYPE.en_US:
          default:
            if (guoZhaoMachine)
              msg = `You are on Guo Zhao, please use ${guoZhaoMachine.MachineName}`;
            else msg = `You are on Guo Zhao at other machine`;
            break;
        }
        throw new Error(msg);
      }

      if (!machine || machine.Available == false) {
        const UserInfo = AppCtrl.userInfo();
        const lockedMachine =
          UserInfo.BindedMachines.length > 0
            ? userInfo.BindedMachines[0]
            : null;

        if (AppCtrl.NeedGobackMachine() === true && lockedMachine) {
          switch (AppCtrl.getLanguage()) {
            case LANGUAGE_TYPE.zh_TW:
              throw new Error(
                `用戶${UserInfo.nickName()}仍在${lockedMachine.Lobby}的機台 ${
                  lockedMachine.MachineName
                }，請先退出機台。`
              );
            case LANGUAGE_TYPE.en_US:
            default:
              throw new Error(
                `Player ${UserInfo.nickName()} still use ${
                  lockedMachine.Lobby
                }-${
                  lockedMachine.MachineName
                },go back the machine and release it first.`
              );
          }
        } else {
          throw new Error(
            `該機器無效(可能有人在使用): [${arduinoIndex}-${machineIndex}]`
          );
        }
      }

      let bLockGuoZhao = false;
      console.log(`canGuoZhao: ${machine.canGuoZhao ? "true" : "false"}`);
      console.log(
        `GuoZhaoEnabled: ${userInfo.GuoZhaoEnabled ? "true" : "false"}`
      );
      
      // if machine is able to GuoZhao, check play mode
      if (!AppCtrl.isRobotMode()) {
        if (machine.canGuoZhao && userInfo.GuoZhaoEnabled) {
          // user's on GuoZhao, keep GuoZhao play mode
          if (guoZhaoInfo != null) {
            bLockGuoZhao = true;
          } else {
            const myPromise = new Promise((resolve, reject) => {
              try {
                let title = "";
                let message = "";
                let okText = "";
                let cancelText = "";
                let TrialGuoZhaoMachine = "";
                let InGuoZhaoScore = machine.inGuoZhaoScore;
                let PaidGuoZhaoScore = machine.outGuoZhaoScore - InGuoZhaoScore;
                let UnlockGuoZhaoScore = machine.unlockGuoZhaoScore;
                let GuoZhaoUnlockWhenWinAward = machine.guoZhaoUnlockWhenWinAward;
                let UserCoin = machine.isTrial
                  ? userInfo.InTrialCoins - userInfo.OutTrialCoins
                  : userInfo.InCoins - userInfo.OutCoins;

                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    TrialGuoZhaoMachine = machine.isTrial
                      ? "銀幣機台:"
                      : "金幣機台:";
                    message = "請選遊戲模式";
                    if (!GuoZhaoUnlockWhenWinAward) {
                      title = `${TrialGuoZhaoMachine}
                                                開招會預扣分數 
                                                開分:${InGuoZhaoScore.toLocaleString()}
                                                贈分:${PaidGuoZhaoScore.toLocaleString()}
                                                過招分:${UnlockGuoZhaoScore.toLocaleString()}
                                                目前錢包分數:${UserCoin.toLocaleString()}`;
                    } else {
                      title = `${TrialGuoZhaoMachine}
                                              開招會預扣分數 
                                              開分:${InGuoZhaoScore.toLocaleString()}
                                              贈分:${PaidGuoZhaoScore.toLocaleString()}
                                              過招條件:${"得獎解招"}
                                              目前錢包分數:${UserCoin.toLocaleString()}`;
                    }
                    okText = "開招";
                    cancelText = "一般";
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    TrialGuoZhaoMachine = machine.isTrial
                      ? "Trial Machine:"
                      : "Gold:";
                    message = "choose playing mode";
                    if (!GuoZhaoUnlockWhenWinAward) {
                      title = `${TrialGuoZhaoMachine}
                                                guo zhao will fill scores to machine before entering 
                                                Keyin:${InGuoZhaoScore.toLocaleString()}
                                                award:${PaidGuoZhaoScore.toLocaleString()}
                                                unlock:${UnlockGuoZhaoScore.toLocaleString()}
                                                Gold:${UserCoin.toLocaleString()}`;
                    } else {
                      title = `${TrialGuoZhaoMachine}
                                                guo zhao will fill scores to machine before entering 
                                                Keyin:${InGuoZhaoScore.toLocaleString()}
                                                award:${PaidGuoZhaoScore.toLocaleString()}
                                                unlock:${"Win Award"}
                                                Gold:${UserCoin.toLocaleString()}`;
                    }
                    okText = "guo zhao";
                    cancelText = "normal";
                    break;
                }
                // do confirm
                showAlert({
                  title: title,
                  text: message,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: okText,
                  cancelButtonText: cancelText,
                  confirmCb: function () {
                    resolve(true);
                  },
                  cancelCb: function () {
                    resolve(false);
                  },
                });
                // Swal.fire({
                //   title: title,
                //   text: message,
                //   icon: "warning",
                //   showCancelButton: true,
                //   confirmButtonColor: "#d33",
                //   cancelButtonColor: "#3085d6",
                //   confirmButtonText: okText,
                //   cancelButtonText: cancelText,
                // }).then(function (result) {
                //   if (result.isConfirmed) {
                //     resolve(true);
                //   } else {
                //     resolve(false);
                //   }
                // });
              } catch (err) {
                resolve(false);
              }
            });
            bLockGuoZhao = await myPromise;
          }
        }
      }

      const warning = await playMachine(machine, bLockGuoZhao);
      if (!AppCtrl.isRobotMode()) {
          if (warning != "") {
              const msg = `<div style={{color:"#ffffff"}}>${warning}</div>`;
              showAlert({ title: msg });
          }
      }
    } catch (error) {
      showAlert({ title: error.message });
      //   AppCtrl.alert(error.message);
    }
    mBlockingChooseMachine = false;
  }

  function onShowDescBtnClicked(e) {
    const ui = e.currentTarget;
    const id = e.currentTarget.id;
    if (ui) {
      const strParams = id.split("_");
      if (strParams.length >= 3) {
        // const arduinoIndex = parseInt(strParams[0]);
        // const machineIndex = parseInt(strParams[1]);
        const pdfName = String(strParams[2]);
        //const typeName = String(pdfName);
        const descName = pdfName + ".pdf";
        window.open(
          descName,
          "game_desc",
          "resizable=yes,scrollbars=yes,status=yes"
        );
        //<iframe src=descName width="100%" height="768px"></iframe>
        //let content = `<iframe src="${descName}" style="width:600px; height:500px;"></iframe>`;
        //let content = `<iframe src=descName width="100%" height="768px"></iframe>';
        //let content = '<iframe src="https://docs.google.com/gview?url="${descName}"&embedded=true" style="width:600px; height:500px;" frameborder="0"></iframe>';
        //AppCtrl.alert(content, '', '', true, '關閉', 0);
      }
    }
  }

  function onSpyBtnClicked(e) {
    const ui = e.currentTarget;
    const id = e.currentTarget.id;
    if (ui) {
      const strParams = id.split("_");
      if (strParams.length >= 3) {
        const arduinoIndex = parseInt(strParams[0]);
        const machineIndex = parseInt(strParams[1]);

        const machine = m_machineInfos[arduinoIndex][machineIndex];
        if (machine) {
          spyMachine(machine);
        } else {
          //AppCtrl.alert(`invalid machine of [${arduinoIndex}-${machineIndex}]`);
          //   AppCtrl.alert(
          //     `錯誤:可能已超做觀看人數上限 [${arduinoIndex}-${machineIndex}]`
          //   );
          showAlert({
            title: `錯誤:可能已超做觀看人數上限 [${arduinoIndex}-${machineIndex}]`,
          });
        }
      }
    }
  }

  function registerEvent(a_machineInfos) {
    for (let i = 0; i < m_machineInfos.length; i++) {
      const machineStatus = m_machineInfos[i];
      for (let j = 0; j < machineStatus.length; j++) {
        const status = machineStatus[j];

        const id = `${i}_${j}`;
        const ui = document.getElementById(id);
        if (ui) {
          ui.addEventListener("click", onChooseMachineBtnClicked);
          uiBtns.push(ui);
        } else {
          //AppCtrl.alert(`ui id:${id} is null`);
          console.log(`ui id:${id} is null`);
        }

        const id_desc = `${i}_${j}_${status.typePic}`;
        const ui_desc = document.getElementById(id_desc);
        if (ui_desc) {
          ui_desc.addEventListener("click", onShowDescBtnClicked);
          uiDescs.push(ui_desc);
        } else {
          console.log(`there are no desc. for ${i}_${j}_${status.typePic}`);
        }

        const id_spy = `${i}_${j}_spy`;
        const ui_spy = document.getElementById(id_spy);
        const machine = m_machineInfos[i][j];
        if (ui_spy && machine.canSpy) {
          ui_spy.addEventListener("click", onSpyBtnClicked);
          uiSpies.push(ui_spy);
        } else {
          console.log(`there are no spy. for ${i}_${j}_spy`);
        }
      }
    }
  }

  function unregisterEvent() {
    if (uiBtns.length > 0) {
      for (let i = 0; i < uiBtns.length; i++) {
        uiBtns[i].removeEventListener("click", onChooseMachineBtnClicked);
      }
      uiBtns.splice(0, uiBtns.length);
    }

    if (uiDescs.length > 0) {
      for (let i = 0; i < uiDescs.length; i++) {
        uiDescs[i].removeEventListener("click", onShowDescBtnClicked);
      }
      uiDescs.splice(0, uiDescs.length);
    }

    if (uiSpies.length > 0) {
      for (let i = 0; i < uiSpies.length; i++) {
        uiSpies[i].removeEventListener("click", onSpyBtnClicked);
      }
      uiSpies.splice(0, uiSpies.length);
    }
  }

  function layoutChooseMachinePanel(a_machineInfos) {
    const uiChooseMachinePanel = document.getElementById("chooseMachinePanel");
    let bNeedReConnect = false;
    m_machineInfos = a_machineInfos;
    if (uiChooseMachinePanel) {
      const ShowSpy = AppCtrl.showSpy();
      const ShowDesc = AppCtrl.showDesc();
      const CasinoName = AppCtrl.getCasinoName();
      const ShowTrialCoins = AppCtrl.showTrialCoins();
      const ShowJackpotDisplay = AppCtrl.showJackpotDisplay();
      const userInfo = AppCtrl.userInfo();

      const btnWidth = 150;
      const btnHeight = 220;
      // background-size:contain;
      const styleImgIcon =
        "position:relative; left:0; top:0; height:100px; object-fit:contain; min-height:100px";
      const styleBtnDesc =
        "position:relative; margin:1px; float:left; left:0; top:0; width:48%; height:50px;";
      const styleBtnSpy =
        "position:relative; margin:1px; float:left; left:0; top:0; width:48%; height:50px;";
      const styleIconTrialCoins =
        "position:relative; margin:1px; float:left; left:0; top:0; width:96%; height:50px;";

      let machineBtnContent = "";
      let iCounter = 0;
      let bChange = false;
      for (let i = 0; i < m_machineInfos.length; i++) {
        let machineStatus = m_machineInfos[i];
        for (let j = 0; j < machineStatus.length; j++) {
          const machine = machineStatus[j];
          let ShowColor = machine.Available ? "white" : "yellow";
          if (
            machine.status === "機台維護中" ||
            machine.status === "Maintain"
          ) {
            const Permission = userInfo.Permission;
            if (Permission < 100) continue;
            ShowColor = "orange";
          }
          // add user name if it exists
          //const DefaultCreditInLimit = objRes.hasOwnProperty("DefaultCreditInLimit") ? objRes["DefaultCreditInLimit"].toString() : "0";
          if (machine.hasOwnProperty("Available") == false) {
            if (!machine.User) machine.Available = true;
            else if (machine.UserName == userInfo.Account)
              machine.Available = true;
            else machine.Available = false;
          }

          /* Create */
          let mainIcon = "";
          if (machine.UserName && machine.UserName == userInfo.Account) {
            mainIcon = `<div style="position:relative;left:0;top:0;z-index:2;width:100%; padding:10px 0px;">
                            <img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="position:absolute; left:0; top:0; width:100%"/>
                            <div style="position:absolute; left:0; top:0; width:100%; text-align:center; color:${ShowColor}">${
              machine.UserName
            }</div>
                        </div>`;
          } else {
            console.log(machine.status);
            mainIcon = `<div style="position:relative;left:0;top:0;z-index:2;width:100%; padding:10px 0px;">
                            <img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="position:absolute; left:0; top:0; width:100%"/>
                            <div style="position:absolute; left:0; top:0; width:100%; text-align:center; color:${ShowColor}">${
              machine.status
            }</div>
                        </div>`;
          }
          let typePic = machine.typePic || machine.TypePic;
          if (typePic) {
            if (typePic.indexOf("_h.png") < 0)
              typePic = typePic.replace(".png", "_h.png");
          } else {
            console.log(`img Erro: ${typePic}`);
            bNeedReConnect = true;
          }

          let mainInfo = "";
          if (ShowTrialCoins) {
            if (
              machine.canGuoZhao &&
              !machine.isTrial &&
              !machine.guoZhaoLeftZeroShowNormal
            )
              mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/KaiZhao.gif?${Math.random()}' style="${styleIconTrialCoins}"/>`;
            else if (
              machine.canGuoZhao &&
              machine.isTrial &&
              !machine.guoZhaoLeftZeroShowNormal
            )
              mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/TrialKaiZhao.gif?${Math.random()}' style="${styleIconTrialCoins}"/>`;
            else if (machine.isTrial)
              mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/Trial.png?${Math.random()}' style="${styleIconTrialCoins}"/>`;
            else
              mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/Gold.png?${Math.random()}' style="${styleIconTrialCoins}"/>`;
          } else {
            if (ShowDesc)
              mainInfo += `<img id="${i}_${j}_${typePic}" src='img/gamelobby/desc.png?${Math.random()}' style="${styleBtnDesc}" />`;

            if (ShowSpy) {
              if (machine.canSpy)
                mainInfo += `<img id="${i}_${j}_spy" src='img/gamelobby/spy.png?${Math.random()}' style="${styleBtnSpy}" />`;
              else
                mainInfo += `<img id="${i}_${j}_spy" src='img/gamelobby/spy.png?${Math.random()}' style="${styleBtnSpy};opacity:0.3"/>`;
            }
          }

          let styleBtnText = "";
          if (CasinoName == "CR星樂柏青哥") {
            styleBtnText = `position:relative; left:0; top:0; width:100%; font-size:10px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/TitleBar.png?${Math.random()}\')`;
          } else if (CasinoName == "588 Casino🎰") {
            if (bChange)
              styleBtnText = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/TitleBar1.png?${Math.random()}\')`;
            else
              styleBtnText = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/TitleBar.png?${Math.random()}\')`;
          } else {
            styleBtnText = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/TitleBar.png?${Math.random()}\')`;
          }

          iCounter++;
          let temp = "";
          //每8台改變Title Bar的貼圖以示區隔
          if (iCounter >= 8) {
            iCounter = 0;
            bChange = !bChange;
            temp += `<br>`;
          }

          //ShowJackpotDisplay
          let joinBonus = machine.joinBonus ? machine.joinBonus : false;
          let styleJackpotDisplay = "";

          let jackpotDisplayHeight = 0;
          if (ShowJackpotDisplay) {
            //bonusType
            jackpotDisplayHeight = 25;
            if (joinBonus)
              styleJackpotDisplay = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/Bonus.gif?${Math.random()}\')`;
            else
              styleJackpotDisplay = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/NonBonus.png?${Math.random()}\')`;
          }

          let machineBtn = "";
          machineBtn += `<div style="margin:2px; float:left; width:${btnWidth}px; height:${
            btnHeight + jackpotDisplayHeight
          }px; border:${
            CasinoName == "CR星樂柏青哥" || CasinoName == "⛩恃悟玩online🎰"
              ? 2
              : 3
          }px #ccc solid;">`;

          machineBtn += ` <div id="${i}_${j}" style="width:100%">`;
          machineBtn += `  <div style="${styleBtnText};color:${
            machine.Available ? "white" : "white"
          }">${machine.MachineName}</div>`;

          let bonusType = machine.bonusType ? machine.bonusType : 0;
          if (ShowJackpotDisplay) {
            if (joinBonus) {
              if (bonusType == 1)
                machineBtn += ` <div style="${styleJackpotDisplay};color:white">${machine.winAToBonus}:${machine.winABase} | ${machine.winBToBonus}:${machine.winBBase}</div>`;
              else
                machineBtn += ` <div style="${styleJackpotDisplay};color:white">${machine.winBToBonus}:${machine.winBBase}</div>`;
            } else
              machineBtn += ` <div style="${styleJackpotDisplay};color:transparent">無彩金</div>`;
          }
          machineBtn += `  ${mainIcon}`;
          machineBtn += `  <img src="${typePic}" style="${styleImgIcon}"/>`;
          machineBtn += " </div>";
          machineBtn += ` <div style="width:100%">${mainInfo}</div>`;
          machineBtn += "</div>";
          machineBtnContent += machineBtn;
          //if(temp != '')
          //    machineBtnContent += temp;
        }
      }

      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-around;
      uiChooseMachinePanel.innerHTML = `<div style="transform: translate(5%,0); display:flex; flex-wrap:wrap">${machineBtnContent}</div>`;
      // proceed reconnect
      if (bNeedReConnect === true) {
        const language = AppCtrl.getLanguage();
        const MachineName = AppCtrl.getCookie("machineName");
        let message;
        let title;
        let btnText;
        switch (language) {
          case LANGUAGE_TYPE.en_US:
          default:
            message = `<div style={{top:"40px", color:"#ffffff"}}>
                            <div>Notice!!!</div> 
                            <div>Please go back to ${MachineName}.</div> 
                            <div>then exit the game again!. Or Login Game Again!</div>
                        </div>`;
            title = "Warning!!!";
            btnText = "OK";
            break;
          case LANGUAGE_TYPE.zh_TW:
            message = `<div style={{top:"40px", color:"#ffffff"}}>
                            <div>請注意!!!</div> 
                            <div>請先回機台: ${MachineName}.</div>
                            <div>然後在退出一次!.或者重新登入遊戲一次</div> 
                        </div>`;
            title = "警告!!!";
            btnText = "確定離開";
            break;
        }
        //do confirm
        if (!AppCtrl.isRobotMode()) {
          showAlert({
              title: message,
              text: title,
              icon: "warning",
              confirmButtonText: btnText,
          });
        }
        
        // Swal.fire({
        //   title: message,
        //   text: title,
        //   icon: "warning",
        //   confirmButtonColor: "#d33",
        //   confirmButtonText: btnText,
        // }).then(function (result) {
        //   if (result.isConfirmed) {
        //     //AppCtrl.getCookie('machineName');
        //   }
        // });
      }
    }
  }

  function layoutChooseMachinePanel_Mobile(a_machineInfos) {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;
    m_machineInfos = a_machineInfos;

    const ShowSpy = AppCtrl.showSpy();
    const ShowDesc = AppCtrl.showDesc();
    const ShowTrialCoins = AppCtrl.showTrialCoins();
    const ShowJackpotDisplay = AppCtrl.showJackpotDisplay();
    const userInfo = AppCtrl.userInfo();
    const layoutType = AppCtrl.layoutType();

    const uiChooseMachinePanel = document.getElementById("chooseMachinePanel");

    let bNeedReConnect = false;
    //uiChooseMachinePanel.innerHTML = '';
    if (layoutType === LayoutType.Fish_Player8) {
      let showHeight = deviceHeight - 90;
      let totalWidth = 0;
      const btnWidth = parseInt(deviceWidth * 0.7);
      const widthRate = parseInt((btnWidth / deviceWidth) * 100);
      const fishMachineWidth = parseInt(btnWidth * 0.7);
      const fishMachineHeight = parseInt(showHeight * 0.7);
      const fishTopPos = parseInt(showHeight * 0.15);

      let titleHeight = parseInt((fishMachineHeight * 10) / 100);
      let titleWidth = parseInt((fishMachineWidth * 70) / 100);
      let titleTop =
        fishTopPos + parseInt(fishMachineHeight / 2) - titleHeight * 2;

      const uiContentMobile = document.getElementById("content_mobile");
      if (uiContentMobile) {
        uiContentMobile.style.paddingTop = "90px";
        uiContentMobile.style.paddingBottom = "0px";
      }
      if (uiChooseMachinePanel) {
        const styleFishMachineImg = `position:absolute; left:15%; top:${fishTopPos}px; width:${fishMachineWidth}px;height:${fishMachineHeight}px;`;

        const playerWidth = parseInt(fishMachineWidth / 4);
        const playerHeight = parseInt(fishMachineHeight / 4);
        const statusHeight = parseInt((playerHeight * 30) / 100);
        const trialCoinHeight = parseInt((playerHeight * 40) / 100);
        const Player1Top = fishTopPos + fishMachineHeight - playerHeight;
        const Player1Left = 25;
        const styleImgStatusPlayer1 = `position:absolute; left:${Player1Left}%; top:${Player1Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer1 = `position:absolute; left:${Player1Left}%; top:${
          Player1Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer1 = `position:absolute; left:${Player1Left}%; top:${
          Player1Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player2Top = Player1Top;
        const Player2Left = 45;
        const styleImgStatusPlayer2 = `position:absolute; left:${Player2Left}%; top:${Player2Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer2 = `position:absolute; left:${Player2Left}%; top:${
          Player2Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer2 = `position:absolute; left:${Player2Left}%; top:${
          Player2Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player3Top = Player2Top - playerHeight + statusHeight;
        const Player3Left = 65;
        const styleImgStatusPlayer3 = `position:absolute; left:${Player3Left}%; top:${Player3Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer3 = `position:absolute; left:${Player3Left}%; top:${
          Player3Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer3 = `position:absolute; left:${Player3Left}%; top:${
          Player3Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player4Top =
          Player3Top - statusHeight - playerHeight - trialCoinHeight;
        const Player4Left = 75;
        const styleImgStatusPlayer4 = `position:absolute; left:${Player4Left}%; top:${Player4Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer4 = `position:absolute; left:${Player4Left}%; top:${
          Player4Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer4 = `position:absolute; left:${Player4Left}%; top:${
          Player4Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player5Top =
          Player4Top - statusHeight - playerHeight - trialCoinHeight;
        const Player5Left = 65;
        const styleImgStatusPlayer5 = `position:absolute; left:${Player5Left}%; top:${Player5Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer5 = `position:absolute; left:${Player5Left}%; top:${
          Player5Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer5 = `position:absolute; left:${Player5Left}%; top:${
          Player5Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player6Top = Player5Top;
        const Player6Left = 40;
        const styleImgStatusPlayer6 = `position:absolute; left:${Player6Left}%; top:${Player6Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer6 = `position:absolute; left:${Player6Left}%; top:${
          Player6Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer6 = `position:absolute; left:${Player6Left}%; top:${
          Player6Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player7Top = Player6Top + parseInt(playerHeight / 2);
        const Player7Left = 15;
        const styleImgStatusPlayer7 = `position:absolute; left:${Player7Left}%; top:${Player7Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer7 = `position:absolute; left:${Player7Left}%; top:${
          Player7Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer7 = `position:absolute; left:${Player7Left}%; top:${
          Player7Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        const Player8Top = titleTop + titleHeight;
        const Player8Left = 7;
        const styleImgStatusPlayer8 = `position:absolute; left:${Player8Left}%; top:${Player8Top}px; width:${playerWidth}px;height:${statusHeight}px;`;
        const styleImgPlayer8 = `position:absolute; left:${Player8Left}%; top:${
          Player8Top + statusHeight
        }px; width:${playerWidth}px;height:${playerHeight}px;`;
        const styleTrialCoinsPlayer8 = `position:absolute; left:${Player8Left}%; top:${
          Player8Top + statusHeight + playerHeight
        }px;width:${playerWidth}px;height:${trialCoinHeight}px;`;

        let machineBtnContent = "";
        let iPlayerID = -1;
        let BuildMainMachineStep = FishTypeBuildMachineStep.Nothing;
        let PlayerNumber = 0;
        let DeviceID = 0;

        for (let m = 0; m < m_machineInfos.length; m++) {
          let machineStatus = m_machineInfos[m];
          let MachineMainstyle = `position:relative;left:${totalWidth}px;top:0px;z-index:2;width:${
            widthRate - 1
          }%;padding-bottom: 0px;`;

          if (machineStatus.length >= 1) DeviceID = machineStatus[0].deviceId;

          let icalPlayerID = parseInt(DeviceID / 8);
          if (
            iPlayerID != icalPlayerID &&
            BuildMainMachineStep === FishTypeBuildMachineStep.Nothing
          ) {
            iPlayerID = icalPlayerID;
            BuildMainMachineStep =
              FishTypeBuildMachineStep.StartBuildMainMachine;
          } else if (
            iPlayerID != icalPlayerID &&
            BuildMainMachineStep != FishTypeBuildMachineStep.Nothing
          ) {
            machineBtnContent += `</div>`;
            BuildMainMachineStep =
              FishTypeBuildMachineStep.StartBuildMainMachine;
            iPlayerID = icalPlayerID;
          }

          for (let n = 0; n < machineStatus.length; n++) {
            let machine = machineStatus[n];
            PlayerNumber = machine.deviceId % 8;
            let WholeMachineBtn = "";

            let PlayerPic = "";
            let typePic = machine.typePic || machine.TypePic;
            if (typePic) {
              if (typePic.indexOf("_h.png") >= 0)
                typePic = typePic.replace("_h.png", ".png");
            } else {
              console.log(`img Erro: ${typePic}`);
              bNeedReConnect = true;
            }

            if (
              BuildMainMachineStep ===
              FishTypeBuildMachineStep.StartBuildMainMachine
            ) {
              //要建立魚機主機圖片
              let titleScript = "";
              let DevicePic = "";
              let DeviceTypePic = machine.typePic || machine.TypePic;
              if (DeviceTypePic.indexOf("_h.png") >= 0) {
                DeviceTypePic = DeviceTypePic.replace("_h.png", "_device.png");
              } else {
                console.log(`img Erro: ${DeviceTypePic}`);
                bNeedReConnect = true;
              }

              titleScript = `<img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="position:absolute;left:20%; top:${titleTop}px; width:${titleWidth}px;height:${titleHeight}px;"/>
                                <div style="position:absolute;left:20%; top:${titleTop}px; width:${titleWidth}px; text-align:center;color:white">${
                machine.MachineName
              }</div>`;
              DevicePic = `<img src="${DeviceTypePic}?${Math.random()}" style="${styleFishMachineImg}"/>`;
              WholeMachineBtn += `<div style="${MachineMainstyle}">
                                                ${DevicePic}${titleScript}`;
              BuildMainMachineStep = FishTypeBuildMachineStep.StartBuildPlayer;
              totalWidth += btnWidth;
            }

            let mainIcon = "";
            let mainInfo = "";
            let ShowColor = machine.Available ? "white" : "yellow";
            let newPlayer = false;
            let styleImgStatusPlayer;
            let styleImgPlayer;
            let styleTrialCoinsPlayer;
            let styleTextNamePlayer;
            let playerNameTop = 0;
            switch (PlayerNumber) {
              case 0:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer1;
                styleImgPlayer = styleImgPlayer1;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer1;
                styleTextNamePlayer = Player1Left;
                playerNameTop = Player1Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 1:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer2;
                styleImgPlayer = styleImgPlayer2;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer2;
                styleTextNamePlayer = Player2Left;
                playerNameTop = Player2Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 2:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer3;
                styleImgPlayer = styleImgPlayer3;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer3;
                styleTextNamePlayer = Player3Left;
                playerNameTop = Player3Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 3:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer4;
                styleImgPlayer = styleImgPlayer4;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer4;
                styleTextNamePlayer = Player4Left;
                playerNameTop = Player4Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 4:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer5;
                styleImgPlayer = styleImgPlayer5;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer5;
                styleTextNamePlayer = Player5Left;
                playerNameTop = Player5Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 5:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer6;
                styleImgPlayer = styleImgPlayer6;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer6;
                styleTextNamePlayer = Player6Left;
                playerNameTop = Player6Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 6:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer7;
                styleImgPlayer = styleImgPlayer7;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer7;
                styleTextNamePlayer = Player7Left;
                playerNameTop = Player7Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
              case 7:
                newPlayer = true;
                styleImgStatusPlayer = styleImgStatusPlayer8;
                styleImgPlayer = styleImgPlayer8;
                styleTrialCoinsPlayer = styleTrialCoinsPlayer8;
                styleTextNamePlayer = Player8Left;
                playerNameTop = Player8Top;
                BuildMainMachineStep =
                  FishTypeBuildMachineStep.StartBuildPlayer;
                break;
            }

            if (newPlayer) {
              if (machine.UserName && machine.UserName == userInfo.Account) {
                mainIcon = `<img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="${styleImgStatusPlayer}"/>
                                    <div style="position:absolute;left:${styleTextNamePlayer}%; top:${playerNameTop}px; width:${playerWidth}px; text-align:center; color:${ShowColor};zIndex:5">${
                  machine.UserName
                }</div>`;
              } else {
                console.log(machine.status);
                mainIcon = `<img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}"style="${styleImgStatusPlayer}"/>                    
                                <div style="position:absolute;left:${styleTextNamePlayer}%; top:${playerNameTop}px; width:${playerWidth}px; text-align:center; color:${ShowColor};zIndex:5">${
                  machine.status
                }</div>`;
              }
              PlayerPic = `<img src="${typePic}?${Math.random()}" style="${styleImgPlayer}"/>`;
              if (ShowTrialCoins) {
                if (
                  machine.canGuoZhao &&
                  !machine.isTrial &&
                  !machine.guoZhaoLeftZeroShowNormal
                )
                  mainInfo += `<img src='img/gamelobby/KaiZhao.gif?${Math.random()}' style="${styleTrialCoinsPlayer}"/>`;
                else if (
                  machine.canGuoZhao &&
                  machine.isTrial &&
                  !machine.guoZhaoLeftZeroShowNormal
                )
                  mainInfo += `<img src='img/gamelobby/TrialKaiZhao.gif?${Math.random()}' style="${styleTrialCoinsPlayer}"/>`;
                else if (machine.isTrial)
                  mainInfo += `<img src='img/gamelobby/Trial.png?${Math.random()}' style="${styleTrialCoinsPlayer}"/>`;
                else
                  mainInfo += `<img src='img/gamelobby/Gold.png?${Math.random()}' style="${styleTrialCoinsPlayer}"/>`;
              }
              WholeMachineBtn += `<div id="${m}_${n}">
                                                ${mainIcon}${PlayerPic}${mainInfo}
                                                </div>`;
            }

            if (
              BuildMainMachineStep === FishTypeBuildMachineStep.StartBuildPlayer
            ) {
              machineBtnContent += WholeMachineBtn;
            }
          }
        }
        uiChooseMachinePanel.innerHTML = machineBtnContent;
      }
    } else {
      let showHeight = deviceHeight - 90;
      let statusHeight = parseInt((showHeight * 10) / 100);
      let titleHeight = parseInt((showHeight * 10) / 100);
      let trialCoinHeight = parseInt((showHeight * 20) / 100);
      let spyBtnHeight = parseInt((showHeight * 20) / 100);
      let machineHeight = parseInt((showHeight * 40) / 100);
      let totalWidth = 0;
      if (!ShowDesc) machineHeight = machineHeight + spyBtnHeight;
      let machineWidth = parseInt(machineHeight * 0.7);

      const btnWidth = parseInt(machineWidth * 1.5);
      const widthRate = parseInt((btnWidth / deviceWidth) * 100);
      let widthGap = parseInt((btnWidth * 25) / 100);
      let TopIconTrialCoins = titleHeight + statusHeight + machineHeight;

      let TopBtnDesc = TopIconTrialCoins + trialCoinHeight;

      const uiContentMobile = document.getElementById("content_mobile");
      if (uiContentMobile) {
        uiContentMobile.style.paddingTop = "90px";
        uiContentMobile.style.paddingBottom = "0px";
      }
      if (uiChooseMachinePanel) {
        const styleImgIcon = `position:absolute; left:11.5%; top:${
          titleHeight + statusHeight
        }px; width:${machineWidth}px;height:${machineHeight}px;`;
        const styleIconTrialCoins = `position:absolute; left:0; top:${TopIconTrialCoins}px; width:100%;height:${trialCoinHeight}px;`;
        const styleBtnDesc = `position:absolute; left:0; top:${TopBtnDesc}px; width:50%;height:${spyBtnHeight}px;`;
        const styleBtnSpy = `position:absolute; right:0; top:${TopBtnDesc}px; width:50%;height:${spyBtnHeight}px;`;

        let machineBtnContent = "";
        let bshowMaintainMachine = Config.showMaintainMachine
          ? Config.showMaintainMachine
          : false;
        for (let i = 0; i < m_machineInfos.length; i++) {
          let machineStatus = m_machineInfos[i];

          for (let j = 0; j < machineStatus.length; j++) {
            const machine = machineStatus[j];
            let ShowColor = machine.Available ? "white" : "yellow";
            if (
              machine.status === "機台維護中" ||
              machine.status === "Maintain"
            ) {
              const Permission = userInfo.Permission;
              if (Permission < 100 && bshowMaintainMachine === false) {
                continue;
              }
              ShowColor = "orange";
            }

            // add user name if it exists
            //const DefaultCreditInLimit = objRes.hasOwnProperty("DefaultCreditInLimit") ? objRes["DefaultCreditInLimit"].toString() : "0";
            if (machine.hasOwnProperty("Available") == false) {
              if (!machine.User) machine.Available = true;
              else if (machine.UserName == userInfo.Account)
                machine.Available = true;
              else machine.Available = false;
            }

            //ShowJackpotDisplay
            // let joinBonus = machine.joinBonus ? machine.joinBonus : false;
            // let styleJackpotDisplay = "";

            // let jackpotDisplayHeight = 0;
            // if(ShowJackpotDisplay)
            // {
            //   //bonusType
            //   jackpotDisplayHeight = 25;
            //   if(joinBonus)
            //     styleJackpotDisplay = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/Bonus.gif?${Math.random()}\')`;
            //   else
            //     styleJackpotDisplay = `position:relative; left:0; top:0; width:100%; font-size:14px; padding:10px 0px; border-width:0; background-size:contain; background-repeat:no-repeat; background-position:center center; background-color:transparent; background-image:url(\'img/gamelobby/NonBonus.png?${Math.random()}\')`;

            // }

            let machineBtn = "";
            let MachineMainstyle = `position:relative;left:${totalWidth}px;top:0px;z-index:2;width:${
              widthRate - 1
            }%;padding-bottom: 0px;`;

            // let bonusType = machine.bonusType ? machine.bonusType : 0;
            // if(ShowJackpotDisplay)
            // {

            //   if (joinBonus)
            //   {
            //     if(bonusType == 1)
            //       machineBtn += ` <div style="${styleJackpotDisplay};color:white">${machine.winAToBonus}:${machine.winABase} | ${machine.winBToBonus}:${machine.winBBase}</div>`;
            //     else
            //       machineBtn += ` <div style="${styleJackpotDisplay};color:white">${machine.winBToBonus}:${machine.winBBase}</div>`;
            //   }
            //   else
            //     machineBtn += ` <div style="${styleJackpotDisplay};color:transparent">無彩金</div>`;
            // }

            /* Create */
            let mainIcon = "";
            if (machine.UserName && machine.UserName == userInfo.Account) {
              mainIcon = `<img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="position:absolute; left:0; top:0px; width:100%;height:${statusHeight}px;"/>
                                <div style="position:absolute; left:0; top:0; width:100%; text-align:center; color:${ShowColor}">${
                machine.UserName
              }</div>`;
            } else {
              console.log(machine.status);
              mainIcon = `<img src="img/gamelobby/imgUsernameFrameBG.png?${Math.random()}" style="position:absolute; left:0; top:0; width:100%;height:${statusHeight};"/>                    
                                <div style="position:absolute; left:0; top:0; width:100%; text-align:center; color:${ShowColor}">${
                machine.status
              }</div>`;
            }
            totalWidth += btnWidth + widthGap;
            let titleScript = "";
            titleScript = `<img src="img/gamelobby/TitleBar.png?${Math.random()}" style="position:absolute; left:0; top:${statusHeight}px; width:100%;height:${titleHeight}px;"/>
                                <div style="position:absolute; left:0; top:${statusHeight}px; width:100%; text-align:center;color:${
              machine.Available ? "white" : "white"
            }">${machine.MachineName}</div>`;

            let MachinePic = "";
            let typePic = machine.typePic || machine.TypePic;
            if (typePic) {
              if (typePic.indexOf("_h.png") >= 0)
                typePic = typePic.replace("_h.png", ".png");
            } else {
              console.log(`img Erro: ${typePic}`);
              bNeedReConnect = true;
            }
            MachinePic = `<img src="${typePic}?${Math.random()}" style="${styleImgIcon}"/>`;

            let mainInfo = "";
            if (ShowTrialCoins) {
              if (
                machine.canGuoZhao &&
                !machine.isTrial &&
                !machine.guoZhaoLeftZeroShowNormal
              )
                mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/KaiZhao.gif?${Math.random()}' style="${styleIconTrialCoins}"/>`;
              else if (
                machine.canGuoZhao &&
                machine.isTrial &&
                !machine.guoZhaoLeftZeroShowNormal
              )
                mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/TrialKaiZhao.gif?${Math.random()}' style="${styleIconTrialCoins}"/>`;
              else if (machine.isTrial)
                mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/Trial.png?${Math.random()}' style="${styleIconTrialCoins}"/>`;
              else
                mainInfo += `<img id="${i}_${j}_${typePic}_Icon" src='img/gamelobby/Gold.png?${Math.random()}' style="${styleIconTrialCoins}"/>`;

              if (ShowDesc)
                mainInfo += `<img id="${i}_${j}_${typePic}" src='img/gamelobby/desc.png?${Math.random()}' style="${styleBtnDesc}" />`;
              /* else
                                mainInfo +=`<img id="${i}_${j}_${typePic}" src='img/gamelobby/desc.png?${Math.random()}' style="${styleBtnDesc};opacity:0.3"/>`;
                            */
              if (ShowSpy && machine.canSpy)
                mainInfo += `<img id="${i}_${j}_spy" src='img/gamelobby/spy.png?${Math.random()}' style="${styleBtnSpy}" />`;
              /* else
                                mainInfo +=`<img id="${i}_${j}_spy" src='img/gamelobby/spy.png?${Math.random()}' style="${styleBtnSpy};opacity:0.3"/>`; */
            }
            machineBtn += `<div style="${MachineMainstyle}">
                                            <div id="${i}_${j}">
                                            ${mainIcon}
                                            ${titleScript}
                                            ${MachinePic}
                                            </div>
                                            ${mainInfo}
                                        </div>`;
            machineBtnContent += machineBtn;
          }
        }
        uiChooseMachinePanel.innerHTML = machineBtnContent;
      }
    }

    if (bNeedReConnect === true) {
      const language = AppCtrl.getLanguage();
      const MachineName = AppCtrl.getCookie("machineName");
      let message;
      let title;
      let btnText;
      switch (language) {
        case LANGUAGE_TYPE.en_US:
        default:
          message = `<div style={{top:"40px", color:"#ffffff"}}>
                        <div>Notice!!!</div> 
                        <div>Please go back to ${MachineName}.</div> 
                        <div>then exit the game again!. Or Login Game Again!</div>
                    </div>`;
          title = "Warning!!!";
          btnText = "OK";
          break;
        case LANGUAGE_TYPE.zh_TW:
          message = `<div style={{top:"40px", color:"#ffffff"}}>
                        <div>請注意!!!</div> 
                        <div>請先回機台: ${MachineName}.</div>
                        <div>然後在退出一次!.或者重新登入遊戲一次</div> 
                    </div>`;
          title = "警告!!!";
          btnText = "確定離開";
          break;
      }
      //do confirm
      if (!AppCtrl.isRobotMode()) {
        showAlert({
            title: message,
            text: title,
            icon: "warning",
            confirmButtonText: btnText,
        });
      }
      
      // Swal.fire({
      //   title: message,
      //   text: title,
      //   icon: "warning",
      //   confirmButtonColor: "#d33",
      //   confirmButtonText: btnText,
      // }).then(function (result) {
      //   if (result.isConfirmed) {
      //     //AppCtrl.getCookie('machineName');
      //   }
      // });
    }
  }

  function render() {
    // 你每頁要換圖，就在這裡準備「該頁的圖片設定」
    // 下面是範例命名；請換成你 AnimatedBG 實際支援的 props / 變數
    const bgVars = {
      // 直向
      "--bg-base-portrait": `url("img/bg/lobby/base_p.png")`,
      "--bg-particles-portrait": `url("img/bg/lobby/particles_p.png")`,
      "--bg-glow-portrait": `url("img/bg/lobby/glow_p.png")`,
      // 橫向
      "--bg-base-landscape": `url("img/bg/lobby/base_l.png")`,
      "--bg-particles-landscape": `url("img/bg/lobby/particles_l.png")`,
      "--bg-glow-landscape": `url("img/bg/lobby/glow_l.png")`,
    };
    return (
      <div className={styles.pageRoot} style={bgVars}>
        {/* ✅ 背景層：固定在最底 */}
        <AnimatedBG className={styles.animatedBg} />

        {/* ✅ 內容層：確保在背景之上 */}
        <div className={styles.pageContent}>
          {/* ...existing code... */}

          {/* 機器人倒數：z-index 記得要比 pageContent 再高或用 fixed */}
        {/* 機器人模式倒數：右上角固定顯示 */}
        {AppCtrl.isRobotMode() && robotCountdown !== null && (
          <div
            id="robotCountdown"
            style={{
              position: "fixed",
              right: "8px",
              top: "8px",
              zIndex: 9999,
              color: "#fff",
              background: "rgba(0,0,0,0.6)",
              padding: "6px 10px",
              borderRadius: "4px",
              fontWeight: "bold",
            }}
          >
            自動進入倒數: {formatCountdown(robotCountdown)}
          </div>
        )}
        {/* 原本畫面 */}
        {!mobileMode ? (
          <div id="chooseMachines" className={styles.chooseMachines_mobile}>
            <div id="mainAreaInLobby" className={styles.mainArea_mobile}>
              <div
                id="headerBar"
                className={styles.header_mobile}
                style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
              >
                <input
                  id="exitButton"
                  type="image"
                  src="img/lobbyui/exit.png"
                  style={{
                    margin: "0 1px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={backToMainPage}
                ></input>
                <input
                  id="chatButton"
                  type="image"
                  src="img/lobbyui/chat.png"
                  style={{
                    margin: "0 1px",
                    float: "left",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onChat}
                ></input>
                <label
                  id="showTitle"
                  style={{
                    paddingLeft: "10px",
                    margin: "15px auto",
                    float: "center",
                    fontSize: "24px",
                  }}
                ></label>
              </div>
              <div className={styles.broadcastbar_mobile}>
                <BroadcastPanel broadcasts={broadcasts} />
              </div>
              {Config?.showJackpot && Config?.urlBonus?.trim() !== "" && (
                <div
                  ref={containerRef}
                  style={{
                    maxWidth: "600px",
                    height: "350px",
                    position: "relative",
                  }}
                >
                  <iframe
                    ref={iframeRef}
                    src={`${Config.urlBonus}/bonusClient/bonus?isShowBg=false`}
                    style={{
                      width: "1920px",
                      height: "1080px",
                      transformOrigin: "0 0",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      border: "none",
                    }}
                  />
                </div>
              )}
              <div id="content_mobile" className={styles.content_mobile}>
                <div
                  id="chooseMachinePanel"
                  className={styles.chooseMachinePanel_mobile}
                ></div>
              </div>
            </div>
          </div>
        ) : (
          <div id="chooseMachines" className={styles.chooseMachines}>
            <div id="mainAreaInLobby" className={styles.mainArea}>
              <div
                className={styles.header}
                style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
              >
                <input
                  id="exitButton"
                  type="image"
                  src="img/lobbyui/exit.png"
                  style={{
                    margin: "0 1px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={backToMainPage}
                ></input>
                <input
                  id="chatButton"
                  type="image"
                  src="img/lobbyui/chat.png"
                  style={{
                    margin: "0 1px",
                    float: "left",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onChat}
                ></input>
                <label
                  id="showTitle"
                  style={{
                    paddingLeft: "10px",
                    margin: "15px auto",
                    float: "center",
                    fontSize: "24px",
                  }}
                ></label>
              </div>
              <div className={styles.broadcastbar}>
                <BroadcastPanel broadcasts={broadcasts} />
              </div>
              <div className={styles.content}>
                <Banners />
                {Config?.showJackpot && Config?.urlBonus?.trim() !== "" && (
                  <div
                    ref={containerRef}
                    style={{
                      maxWidth: "600px",
                      height: "350px",
                      position: "relative",
                    }}
                  >
                    <iframe
                      ref={iframeRef}
                      src={`${Config.urlBonus}/bonusClient/bonus?isShowBg=false`}
                      style={{
                        width: "1920px",
                        height: "1080px",
                        transformOrigin: "0 0",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        border: "none",
                      }}
                    />
                  </div>
                )}
                <div
                  id="chooseMachinePanel"
                  className={styles.chooseMachinePanel}
                ></div>
              </div>
              {
                // <div className={styles.footer}>
                // </div>
              }
            </div>
          </div>
        )}
      </div>
    </div>
    );
  }

  return render();
}

export default LobbyPage;
